import * as Common from '@/common/main';
import { expose } from '@/utils/expose';

expose('Common', Common, true);
